import { SectionTitle } from '@/components/shared/Content';
import JoinCTA from '@/components/shared/JoinCTA';
import { Box, Flex, font, themedColor } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import { COLORS } from '@lemonade-hq/tokens';
import styled from 'styled-components';

export const ProductBox = styled(Flex).attrs({
  as: 'li',
})<{ readonly cardsWidth?: { mobile: number; desktop: number } }>`
  background-color: ${COLORS.white};
  border-radius: 10px;
  box-shadow:
    0 47px 46px -27px rgba(0, 0, 0, 0.16),
    0 2px 12px 0 rgba(0, 0, 0, 0.06);
  ${font('main')};
  align-items: center;
  flex-direction: column;
  justify-content: space-between;

  ${MEDIA_QUERIES.mobile`
      padding: 6px 12px 16px 12px;
      width: ${({ cardsWidth }) => cardsWidth.mobile}px;
  `}

  ${MEDIA_QUERIES.tabletAndDesktop`
      padding: 5px 10px 29px 10px;
      width: ${({ cardsWidth }) => cardsWidth.desktop}px;
  `}
`;

interface IProductImage {
  readonly imageMobile: StaticImageData;
  readonly imageDesktop: StaticImageData;
}

export const ProductImage = styled(Box)`
  width: 106px;
  height: 106px;

  ${({ imageMobile }: IProductImage) => `background: url(${imageMobile.src}) center no-repeat;`}
  background-size: contain;

  ${MEDIA_QUERIES.tabletAndDesktop`
    width: 150px;
    height: 150px;

    ${({ imageDesktop }: IProductImage) => `background: url(${imageDesktop.src}) center no-repeat;`}
    background-size: auto;
    background-position: bottom;
  `}
`;

export const ProductsSectionTitle = styled(SectionTitle)<{ withSubtitle: boolean }>`
  max-width: 85%;
  margin: 0 auto;
  white-space: initial;
  text-wrap: balance;
  margin-bottom: ${({ withSubtitle }) => (withSubtitle ? '0px' : '30px')};
`;

export const ProductTitle = styled.span`
  display: block;
  ${font('main', { fontSize: '1.8rem', fontWeight: 'bold' })};
  white-space: pre;
  text-align: center;
  color: ${themedColor('night')};

  ${MEDIA_QUERIES.tabletAndDesktop`
        font-size: 2.7rem;
    `}
`;

export const ProductSubtitle = styled.span`
  display: block;
  ${font('main', { fontSize: '1.6rem' })};
  color: ${themedColor('night')};
  white-space: pre-wrap;
  text-align: center;
  text-wrap: balance;
  display: none;

  ${MEDIA_QUERIES.tabletAndDesktop`
    display: block;
  `}
`;

export const PricePeriod = styled.span`
  display: block;
  ${font('main', { fontSize: '1rem', fontWeight: 'bold' })};
  color: ${COLORS.darkGray};
  text-transform: uppercase;
  text-align: center;
  margin-top: 12px;

  ${MEDIA_QUERIES.tabletAndDesktop`
        font-size: 1.2rem;
    `}
`;

export const CTA = styled(JoinCTA)`
  &&& {
    display: block;
    width: 194px;

    ${MEDIA_QUERIES.mobile`
            width: 126px;
            font-size: 1.2rem;
            height: 40px;
            padding: 11px;
        `}
  }
`;
